import { FaustHooks } from "@faustwp/core";

export class CeremonyRewrite {
	/**
	 * @param {FaustHooks} hooks
	 */
	apply(hooks: FaustHooks) {
    const { addFilter } = hooks;
		addFilter(
			"resolvedUrl",
			"rockhall",
			(resolvedUrl) => {
				const inducteeClassPattern = /^\/([a-z]{2})?\/?inductees\/classes\/(\d{4})\/?$/;
				const inducteeClassLandingPattern = /^\/([a-z]{2})?\/?inductees\/classes\/?$/;
				const classMatch = resolvedUrl.match(inducteeClassPattern);
				const landingMatch = resolvedUrl.match(inducteeClassLandingPattern);
				if (classMatch) {
					const locale = classMatch[1] ? classMatch[1] : "";
					const year = classMatch[2];
					return `/${locale ? locale + "/" : ""}ceremony/${year}/`;
				} else if (landingMatch) {
					const locale = landingMatch && landingMatch[1] ? landingMatch[1] : "";
					return `/${locale ? locale + "/" : ""}inductees/`;
				}
				return resolvedUrl;
			},
		);
	}
}